import { render, staticRenderFns } from "./StartupsModalRow.vue?vue&type=template&id=f31fce1a&scoped=true&"
import script from "./StartupsModalRow.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsModalRow.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31fce1a",
  null
  
)

export default component.exports